import { useMemo, type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import 'dayjs/locale/pt'
import ConfirmProvider from '../components/ConfirmProvider'
import { buildTheme, type ThemeLanguage } from '.'

/**
 * Tema + locale dos selectores de data na língua da interface. Tem de ser o
 * `ThemeProvider` do MUI (e não o do Emotion): só ele distribui os
 * `defaultProps` e os textos de locale definidos no tema.
 */
export default function AppThemeProvider({ children }: { children: ReactNode }) {
  const { i18n } = useTranslation()
  const lang: ThemeLanguage = i18n.resolvedLanguage?.startsWith('en') ? 'en' : 'pt'
  const theme = useMemo(() => buildTheme(lang), [lang])

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={lang}>
        <ConfirmProvider>{children}</ConfirmProvider>
      </LocalizationProvider>
    </ThemeProvider>
  )
}
